import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/77_card_back_halloween/77_card_back_halloween"
 * Contains 1 texture(s)
 */
export class CardsBacks77CardBackHalloweenAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/77_card_back_halloween/77_card_back_halloween';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '77_halloween.png'
    ] as const;
}
